var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.prioridades,"clearable":"","outlined":"","dense":"","item-text":"tipo","item-value":"id","hide-details":"","label":"Prioridade"},on:{"click:clear":_vm.clearPrioridade},model:{value:(_vm.prioridade),callback:function ($$v) {_vm.prioridade=$$v},expression:"prioridade"}})
}
var staticRenderFns = []

export { render, staticRenderFns }